<sdc-bo-dialog
  headerTitle="Are you sure you want to delete this upsell?"
  [styleClass]="['variant-prominent-title']"
  [attr.data-cy]="'upsell-delete-modal-' + data?.id">
  <div class="content-wrapper">
    <div>
      <div class="input-line">
        <div>
          <span><b>Image</b></span>
        </div>
        <div>
          @if (data?.urlImage) {
            <div>
              <img [src]="data.urlImage" />
            </div>
          } @else {
            No image
          }
        </div>
      </div>
      <div class="input-line">
        <div>
          <span><b>Name</b></span>
        </div>
        <div>
          <p>{{ data?.name }}</p>
        </div>
      </div>
      <div class="input-line">
        <div>
          <span><b>Description</b></span>
        </div>
        <div>
          <p>{{ data?.description }}</p>
        </div>
      </div>
      <div class="input-line">
        <div>
          <span><b>Buyer Type ID</b></span>
        </div>
        <div>
          <p>{{ data?.buyerTypeId }}</p>
        </div>
      </div>
      <div class="input-line">
        <div>
          <span><b>Visibility</b></span>
        </div>
        <div>
          <p>{{ data?.active }}</p>
        </div>
      </div>
    </div>
  </div>
  <ng-container sdc-bo-dialog-footer>
    <sdc-button
      [attr.data-cy]="'upsell-delete-modal-cancel-button-' + data?.id"
      variant="secondary"
      (onClick)="onDismiss('cancel')">
      Cancel
    </sdc-button>
    <sdc-button
      [attr.data-cy]="'upsell-delete-modal-confirm-button-' + data?.id"
      variant="destructive"
      (onClick)="onConfirm(data?.id)">
      Permanently delete
    </sdc-button>
  </ng-container>
</sdc-bo-dialog>
